const CAMPAIGNS = [
    {
        title: 'Season kickoff',
        description:
            'Land in mailboxes right before spring and fall demand so your calendar fills first.',
        iconBg: 'bg-secondary/10',
        iconColor: 'text-secondary',
        icon: 'bolt',
        badge: 'Auto-trigger ready',
    },
    {
        title: 'House washing',
        description:
            'Target siding types, home age, and property profiles where dirt, algae, and mildew show most.',
        iconBg: 'bg-[#FAB331]/20',
        iconColor: 'text-secondary',
        icon: 'home',
    },
    {
        title: 'Neighborhood farming',
        description:
            'Stay visible in the streets and ZIPs you want to own, where one clean house sells the next.',
        iconBg: 'bg-[#DBEAFE]',
        iconColor: 'text-[#1E40AF]',
        icon: 'map-pin',
        badge: 'Auto-trigger ready',
    },
    {
        title: 'Annual rebooks',
        description:
            "Bring last year's customers back on schedule for their next wash, and ask for referrals.",
        iconBg: 'bg-[#DCFCE7]',
        iconColor: 'text-[#166534]',
        icon: 'refresh',
    },
    {
        title: 'Bundle offers',
        description:
            'Promote house wash plus driveway, roof, or gutter add-ons to raise average ticket.',
        iconBg: 'bg-secondary/10',
        iconColor: 'text-secondary',
        icon: 'clipboard',
    },
    {
        title: 'Jobsite targeting',
        description:
            'Mail the surrounding homes while your crew and truck are parked on the street.',
        iconBg: 'bg-gray-200',
        iconColor: 'text-gray-600',
        icon: 'target',
    },
]

function CampaignIcon({ name, className }) {
    const icons = {
        bolt: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
        ),
        home: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
        ),
        'map-pin': (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
            </svg>
        ),
        refresh: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <polyline points="23 4 23 10 17 10" />
                <polyline points="1 20 1 14 7 14" />
                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
            </svg>
        ),
        clipboard: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
                <rect x="9" y="3" width="6" height="4" rx="1" />
                <line x1="9" y1="12" x2="15" y2="12" />
                <line x1="9" y1="16" x2="13" y2="16" />
            </svg>
        ),
        target: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <circle cx="12" cy="12" r="6" />
                <circle cx="12" cy="12" r="2" />
            </svg>
        ),
    }
    return icons[name] || null
}

function SparklesIcon({ className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            fill="none"
            width={12}
            height={12}
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            aria-hidden="true">
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
            />
        </svg>
    )
}

export default function CampaignStrategy() {
    return (
        <section className="bg-white">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
                <div className="flex flex-col gap-4 max-w-3xl mb-10">
                    <span className="text-secondary text-xs uppercase tracking-widest font-semibold">
                        Exterior cleaning campaign strategy
                    </span>
                    <h2
                        className="text-[#3f454f] tracking-tight text-3xl md:text-[44px] font-bold"
                        style={{ lineHeight: 1.05 }}>
                        Direct mail built around the cleaning jobs you actually
                        want more of.
                    </h2>
                    <p
                        className="text-[color-mix(in_oklab,_#3F454F_70%,_transparent)] text-lg"
                        style={{ lineHeight: '28px' }}>
                        Reach the homeowners most likely to book house washing,
                        roof and gutter cleaning, driveway and paver work,
                        window cleaning, and annual maintenance plans.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-5">
                    {CAMPAIGNS.map((campaign, i) => (
                        <div
                            key={i}
                            className="group relative flex flex-col gap-4 p-6 lg:p-7 bg-[#FFF7EC] rounded-2xl border border-gray-200/50 transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl">
                            <div
                                className={
                                    campaign.badge
                                        ? 'flex flex-row items-start justify-between gap-3'
                                        : ''
                                }>
                                <div
                                    className={`w-12 h-12 rounded-xl ${campaign.iconBg} flex items-center justify-center transition-transform duration-300 ease-out group-hover:scale-110 group-hover:rotate-3`}>
                                    <CampaignIcon
                                        name={campaign.icon}
                                        className={`w-6 h-6 ${campaign.iconColor}`}
                                    />
                                </div>
                                {campaign.badge && (
                                    <div className="flex flex-row items-center gap-1 px-2 py-px rounded-full bg-transparent border border-secondary/30 -mt-2 -mr-2">
                                        <SparklesIcon className="w-3 h-3 text-secondary" />
                                        <span className="text-[0.625rem] leading-7 font-bold tracking-wider text-secondary uppercase">
                                            {campaign.badge}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <h3
                                className="text-[#3F454F] font-bold text-lg md:text-[22px]"
                                style={{ lineHeight: '28px' }}>
                                {campaign.title}
                            </h3>
                            <p
                                className="text-sm text-[color-mix(in_oklab,_#3F454F_65%,_transparent)]"
                                style={{ lineHeight: 1.625 }}>
                                {campaign.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
